import { render, staticRenderFns } from "./SettlementPaymentTutorial.vue?vue&type=template&id=66c30c7c"
import script from "./SettlementPaymentTutorial.vue?vue&type=script&lang=js"
export * from "./SettlementPaymentTutorial.vue?vue&type=script&lang=js"
import style0 from "./SettlementPaymentTutorial.vue?vue&type=style&index=0&id=66c30c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports